import * as yup from 'yup';
import { alphabetRegix, numericRegix } from '../utils/functions';

const individual_general_information_validation_schema = yup.object().shape({

  areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany: yup
    .string()
    .required('this_field_is_required'),

  describeNameOfTheCompany: yup
    .string()
    .when('areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', {
      is: '1',
      then: (schema) =>
        schema.required('please_describe_name_of_country'),
      otherwise: (schema) => schema.notRequired(),
    }),

  areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany: yup
    .string()
    .required('this_field_is_required'),

  describeYourRelationToTheBoardOfMember: yup
    .string()
    .when('areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', {
      is: '1',
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  areYouEntrustedWithAProminentPosition: yup
    .string()
    .required('this_field_is_required'),

  pleaseSpecifyYourFunctionOrPositionAndYourInstitution: yup
    .string()
    .when('areYouEntrustedWithAProminentPosition', {
      is: '1',
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition: yup
    .string()
    .required('this_field_is_required'),

  pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution: yup
    .string()
    .when('doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition', {
      is: '1',
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  willYouBeTheBeneficialOwnerOfThisAccount: yup
    .string()
    .required('this_field_is_required'),

  nameOfTheBeneficialOwner: yup
    .string()
    .when('willYouBeTheBeneficialOwnerOfThisAccount', {
      is: '0',
      then: (schema) =>
        schema.required('please_enter_name_of_owner')
          .matches(alphabetRegix, 'must_be_alphabetic'),
      otherwise: (schema) => schema.notRequired(),
    }),

  beneficiaryIdNumber: yup
    .string()
    .when('willYouBeTheBeneficialOwnerOfThisAccount', {
      is: '0',
      then: (schema) =>
        schema.required('please_enter_id_of_owner')
          .min(10, 'beneficiary_number_validation')
          .matches(numericRegix, 'beneficiary_number_validation'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default individual_general_information_validation_schema;
